<template>
    <div
        v-if="contest"

    >
        <div class="row" v-if="contest">
            <div class="col-md-12">
                <contest-header/>
            </div>
        </div>
        <div
            v-if="(contest && contest.settings && contest.settings.maintenance == 1) && (user && user.admin_level < 10 || !user ) "
            class="maintenance">
            <h2>
                Maintenance Mode - please come back later
            </h2>
            <p>
                We are currently updating the functionality of this contest to make your experience better!<br/>
                We apologize for the inconvenience - please come back later. <br/><br/>
                <strong>Thank you !</strong><br/>

                NJ Monthly Team</p>
        </div>
        <div v-else-if="(contest && (contest.status === 'completed' || (contest.type !== 'cover_search_contest' && contest.status !== 'submit')) ) && !userIsAdmin ">
            <h2 style="text-align:center">The entry period has ended.</h2>
        </div>
        <div v-else>
            <div
                class="lg:flex lg:flex-wrap lg:flex-row-reverse"
            >
                <div
                    class="w-full lg:w-3/5"
                >

                    <div
                        v-if="contestHasStarted || userIsAdmin"
                    >
                        <contest-form
                            @submitted="formSubmitted"
                        >
                        </contest-form>
                    </div>
                    <div
                        class="text-xl font-semibold"
                        v-else
                        style="margin-top: 18px;"
                    >
                        The contest has not started.
                    </div>
                </div>
                <div
                    class="w-full lg:w-2/5 pr-5"
                    style="margin-top: 18px;"
                >
                    <h1
                        class="text-3xl"
                    >
                        {{ contest.enter_title }}
                    </h1>
                    <div v-html="contest.enter_content"></div>

                    <div>
                        <h4
                            class="mb-3"
                        >
                            Share with your friends!
                        </h4>
                        <div class="share-buttons-container flex">
                            <a class="share-icon"
                               :href="'https://www.facebook.com/sharer/sharer.php?u=' + MAIN_URL + '/contests/' + contest.slug + '/entries/' + '&quote=' + share_text"
                               target="_blank">
                                <div class="facebook-icon">
                                    <facebook-icon/>
                                </div>
                            </a>

                            <a class="share-icon"
                               :href="'http://twitter.com/share?url=' + MAIN_URL + '/contests/' + this.contest.slug + '/entries/' + '&text=' + share_text"
                               target="_blank">
                                <div>
                                    <twitter-icon/>
                                </div>
                            </a>

                            <a class="link-icon-container share-icon"
                               :href="'mailto:?subject=' + share_text + '&body=' + share_text">
                                <email-icon/>
                            </a>

                        </div>
                    </div>
                </div>

            </div><!--end of row-->
        </div> <!-- end of else statement -->
    </div>
</template>

<script>
import { ENV_URL, MAIN_URL, S3_URL } from '../../environment.js';
import EntryForm from '@/js/components/contests/EntryForm.vue';
import ContestHeader from '@/js/components/contests/ContestHeader.vue';
import axios from 'axios';
import FacebookIcon from '@/js/components/ui/FacebookIcon.vue';
import TwitterIcon from '@/js/components/ui/TwitterIcon.vue';
import EmailIcon from '@/js/components/ui/EmailIcon.vue';
import ContestForm from '@/js/components/contests/ContestForm.vue';
import {mapGetters, mapState} from "vuex";
import { sendContestForm } from '@/js/plugins/hubspot.js';

var smoothScroll = require('smoothscroll');

export default {
    components: {
        EntryForm,
        ContestHeader,
        FacebookIcon,
        TwitterIcon,
        EmailIcon,
        ContestForm,
    },
    data() {
        return {
            places: null,
            displayMobileFilters: false,
            MAIN_URL: MAIN_URL,
            S3_URL: S3_URL,
            category: '',
            enteredInContest: false
        }
    },
    computed: {
        ...mapState({
            contest: (state) => state.contest,
            user: (state) => state.user,
        }),
        ...mapGetters({
            submitFormVisible: 'submitFormVisible',
        }),
        entryForm() {
            return this.$store.state.entryForm;
        },
        share_text() {
            return this.$store.state.contest ? "Check out the " + this.contest.title + " Contest!" : '';
        },
        page() {
            return this.$store.state.page;
        },
        contestHasStarted () {
            const startDateTimeString = (this.contest.submit_start).replace(/ /g, 'T'); // safari is confused by dates without the T (2023-03-15 00:00:00 instead of 2023-03-15T00:00:00)
            return new Date() > new Date(startDateTimeString); // now is after the submit start date
        },
        userIsAdmin () {
            return this.user && this.user.admin_level >= 10;
        },
        submitStartFormatted () {
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(this.contest.submit_start).toLocaleDateString("en-US", options);
        }
    },
    mounted() {
        this.getPageData();
    },
    methods: {
        getPageData() {
            this.$store.dispatch('LOADING', true);
            const uri = ENV_URL + this.$route.path;
            this.$store.dispatch('CONTESTS_CONTEST_ENTRIES_CREATE', {uri: uri}).then(() => {
                this.$store.dispatch('LOADING', false);
            });
        },
        formSubmitted() {
            this.$store.dispatch('LOADING', true);
            const data = {
                item: this.entryForm,
                user_id: this.user.id,
                contest_id: this.contest.id,
            }
            const laravelAuthToken = localStorage.getItem('laravelAuthToken');
            let authHeaders = {
                headers: {"Authorization" : `Bearer ${laravelAuthToken}`}
            };
            axios.post(`/api/contests/${this.contest.slug}/entries/create`, data, authHeaders).then((res) => {
                // update the store
                this.$store.commit('setState', { key: 'entry', data: res.data.entry });
                var exampleDestination = document.getElementById('payment-form');
                let path = `/contests/${this.contest.slug}/entries/${res.data.entry.id}/complete`;
                // if this is a student entry, submit the hubspot contest form, and go straight to the Thank You page
                if (this.entryForm.is_student) {
                    const hubspotData = {
                        formData: {
                            name: this.user.name,
                            last_name: this.user.last_name,
                            email: this.user.email,
                        },
                    }
                    sendContestForm(hubspotData, this.contest.slug);
                    path = '/contests/' + this.contest.slug + '/purchase-complete';
                }
                smoothScroll(exampleDestination);
                this.$router.push({path: path, query: {}})
            }).finally(() => {
                this.$store.dispatch('LOADING', false);
            })
        },
        catchError(err) {
            alert(err.response.status + ': ' + err.response.data.message);
            this.is_loading = false;
            return err.response;
        },

    },
    watch: {
        '$route': function (to, from) {
            this.$store.dispatch('TOGGLE_LOADING', {loading: this.$store.state.loading})
        }
    },
}
</script>

<style lang="scss">
.maintenance {
    text-align: center;

    h2 {
        font-size: 40px;
    }
}
</style>




